<script setup lang="ts">
import type { ProgressRootProps } from 'radix-vue'
import type { HTMLAttributes } from 'vue'
import {
	ProgressIndicator,
	ProgressRoot,

} from 'radix-vue'

const props = withDefaults(
	defineProps<ProgressRootProps & { class?: HTMLAttributes['class'] }>(),
	{
		modelValue: 0,
	},
)

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props

	return delegated
})
</script>

<template>
	<progress-root
		v-bind="delegatedProps"
		:class="
			cn(
				'relative h-2 w-full overflow-hidden rounded-full bg-primary/20',
				props.class,
			)
		"
	>
		<progress-indicator
			class="bg-primary size-full flex-1 transition-all"
			:style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
		/>
	</progress-root>
</template>
